import { cn } from "@/helpers";

interface PaginationTabOption {
  id: string | number;
  text: string;
}

interface PaginationTabsProps {
  options: PaginationTabOption[];
  active_option_index: number;
  setActiveOptionIndex: (index: number) => void;
}

export default function PaginationTabs({
  options,
  active_option_index,
  setActiveOptionIndex,
}: PaginationTabsProps) {
  const optionclass = cn(
    "text-primary",
    "px-4 py-1",
    "cursor-pointer",
    "rounded",
    "flex-1",
    "text-center",
  );
  return (
    <div className="mb-4 flex items-center gap-4 rounded bg-slate-800 p-1">
      {options.map((option, i) => {
        return (
          <button
            key={option.id}
            type="button"
            onClick={() => setActiveOptionIndex(i)}
            aria-current={active_option_index === i}
            className={cn(
              optionclass,
              active_option_index === i && "text-future-purple",
              active_option_index === i && "bg-slate-900",
            )}
          >
            {option.text}
          </button>
        );
      })}
    </div>
  );
}
